import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IEmployee } from "../types/employee";
import {
  IUser,
  IUserCount,
  IUserProfilesResponse,
  IUserResponse,
  IUserState,
} from "../types/users";

const initialState: IUserState = {
  users: [],
  user: null,
  total: 0,
  limit: 10,
  offset: 0,
  loading: false,
  loadingUserId: null,
  monthly_total: 0,
  profiles: [],
  counts: {
    total_user: 0,
    total_inactive_user: 0,
    total_active_user: 0,
  },
};

const usersSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUsers: (state, action: PayloadAction<IUserResponse>) => {
      state.users = action.payload.data.items;
      state.total = action.payload.data.total;
      state.limit = action.payload.data.limit;
      state.offset = action.payload.data.offset;
    },
    setUser: (state, action: PayloadAction<IUser>) => {
      state.user = action.payload;
    },
    createUser: (state, action: PayloadAction<IUser>) => {
      if (state.offset === 0) {
        state.users = [
          action.payload,
          ...state.users.filter((user) => user.id !== action.payload.id),
        ].slice(0, state.limit);
      }
      state.total += 1;
    },
    editUser: (state, action: PayloadAction<IUser>) => {
      state.users = state.users.map((user) =>
        user.id === action.payload.id ? action.payload : user,
      );
      if (state.user?.id === action.payload.id) {
        state.user = action.payload;
      }
    },
    updateUserStatus: (
      state,
      action: PayloadAction<{ id: number; is_active: boolean }>,
    ) => {
      state.users = state.users.map((user) =>
        user.id === action.payload.id
          ? { ...user, is_active: action.payload.is_active }
          : user,
      );
      if (state.user?.id === action.payload.id) {
        state.user.is_active = action.payload.is_active;
      }
    },
    deleteUser: (state, action: PayloadAction<number>) => {
      state.users = state.users.filter((user) => user.id !== action.payload);
      state.total = Math.max(0, state.total - 1);
      if (state.user?.id === action.payload) {
        state.user = null;
      }
    },
    setUsersLoading: (state) => {
      state.loading = true;
    },
    disableUsersLoading: (state) => {
      state.loading = false;
    },
    setLoadingUserId: (state, action: PayloadAction<number | null>) => {
      state.loadingUserId = action.payload;
    },
    setMonthlyTotal: (state, action: PayloadAction<number>) => {
      state.monthly_total = action.payload;
    },
    setTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },
    setProfiles: (
      state,
      action: PayloadAction<IUserProfilesResponse | IEmployee[]>,
    ) => {
      state.profiles = Array.isArray(action.payload)
        ? action.payload
        : action.payload.data;
    },
    clearUser: (state) => {
      state.user = null;
    },
    setTotalUser: (state, action: PayloadAction<IUserCount["data"]>) => {
      state.counts = action.payload;
    },
  },
});

export const {
  setUsers,
  setUser,
  createUser,
  editUser,
  updateUserStatus,
  deleteUser,
  setUsersLoading,
  disableUsersLoading,
  setLoadingUserId,
  setMonthlyTotal,
  setTotal,
  setProfiles,
  clearUser,
  setTotalUser,
} = usersSlice.actions;

export default usersSlice.reducer;

// import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import { ICompanyUser, IUserState } from "../types/user";
// import { IProfileResponse } from "../types/employee";

// const initialState: IUserState = {
//   users: [],
//   profiles: [],
//   docFile: [],
//   fileLogs: [],
//   user: null,
//   monthly_total: 0,
//   total: 0,
//   current_page: 1,
//   last_page: 1,
//   loading: false,
//   loadingUserId: null,
// };

// export const opportunity = createSlice({
//   name: "user",
//   initialState,
//   reducers: {
//     setUsers: (state, action) => {
//       state.users = action.payload.data;
//       state.last_page = action.payload.last_page;
//       state.current_page = action.payload.current_page;
//     },
//     setUser: (state, action: PayloadAction<ICompanyUser>) => {
//       state.user = action.payload;
//     },
//     setDeleteUser: (state, action: PayloadAction<string>) => {
//       state.users = state.users.filter((item) => item.email !== action.payload);
//     },
//     setUserFileLog: (state, action) => {
//       state.fileLogs = action.payload;
//     },
//     setUserDocFile: (state, action) => {
//       state.docFile = action.payload;
//     },
//     setSearch: (state, action) => {
//       state.users = action.payload.data;
//     },
//     setUserLoading: (state) => {
//       state.loading = true;
//     },
//     setUserLoadingId: (state, action: PayloadAction<string | null>) => {
//       state.loadingUserId = action.payload;
//     },
//     disableUserLoading: (state) => {
//       state.loading = false;
//     },
//     setTotal: (state, action: PayloadAction<number>) => {
//       state.total = action.payload;
//     },
//     setMonthlyTotal: (state, action: PayloadAction<number>) => {
//       state.monthly_total = action.payload;
//     },
//     setProfiles: (state, action: PayloadAction<IProfileResponse>) => {
//       state.profiles = action.payload.data;
//       state.current_page = action.payload.current_page;
//       state.last_page = action.payload.last_page;
//     },
//     setLoading: (state) => {
//       state.loading = !state.loading;
//     },
//   },
// });

// // Action creators are generated for each case reducer function
// export const {
//   setSearch,
//   setUser,
//   setDeleteUser,
//   setUserLoading,
//   setUserLoadingId,
//   setUserDocFile,
//   setUserFileLog,
//   disableUserLoading,
//   setUsers,
//   setTotal,
//   setMonthlyTotal,
//   setProfiles,
//   setLoading,
// } = opportunity.actions;

// export default opportunity.reducer;
